<template>
  <VenueSubNav
    class="flex flex-row gap-3 items-center justify-start flex-wrap md:gap-6 md:flex-nowrap xl:justify-end"
  >
    <UpdateIndicator
      v-for="link in reportPageLinks"
      :key="link.routeName"
      class="report-page-link perf-page-link-desktop md:block"
      :status="link.isUpdated ? UPDATE_INDICATOR_STATUS.UPDATED : UPDATE_INDICATOR_STATUS.NONE"
      :id="`${link.routeName}-link`"
      v-show="!link.hide"
    >
      <router-link
        activeClass="!text-fg-primary"
        class="text-fg-link-primary"
        :to="{ name: link.routeName }"
      >
        {{ link.label }}
      </router-link>
    </UpdateIndicator>
  </VenueSubNav>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import UpdateIndicator from '@/common/components/atoms/UpdateIndicator.vue'
import { UPDATE_INDICATOR_STATUS } from '@/modules/performance/interfaces/PerformanceTableInterfaces'
import { REPORT_ROUTE_NAMES } from '@/modules/report/constants/ReportRouteNames'
import { useReportUpdateStore } from '@/modules/report/stores/ReportUpdateStore'
import VenueSubNav from '@/modules/venueUi/components/atoms/VenueSubNav.vue'

type ReportPageLink = {
  routeName: string
  label: string
  isUpdated: boolean
  hide?: boolean
}

const { hasUpdates } = storeToRefs(useReportUpdateStore())
const reportPageLinks = computed<ReportPageLink[]>(() => {
  return [
    {
      routeName: REPORT_ROUTE_NAMES.OVERVIEW,
      label: 'Overview',
      isUpdated: false,
    },
    {
      routeName: REPORT_ROUTE_NAMES.SALES,
      label: 'Sales',
      isUpdated: hasUpdates.value,
    },
    {
      routeName: REPORT_ROUTE_NAMES.SHOW_INSIGHTS,
      label: 'Show Insights (Beta)',
      isUpdated: false,
    },
  ]
})
</script>
